export const genericActionCreator = (type, payload = {}) => ({
  type,
  ...payload,
});

export const renameObjectKeys = (object, keys, newKeys) => {
  const updatedObject = { ...object };

  keys.forEach((currentKeys, index) => {
    updatedObject[newKeys[index]] = object[currentKeys];
    delete updatedObject[currentKeys];
  });

  return updatedObject;
};

export const expectDispatchActionWithType = (dispatch, type) => {
  expect(dispatch).toBeCalledWith(
    expect.objectContaining({
      type,
    }),
  );
};

class MockedStore {
  constructor(defaultState) {
    this.currentState = defaultState;
    this.dispatch = jest.fn();
  }

  getState() {
    return this.currentState;
  }
}

export const getMockedStore = defaultState => new MockedStore(defaultState);
